import React from 'react'
import styled from 'styled-components'
import { SCREEN_SIZE } from '../../lib/Media'
import Text from '../../components/Text'

import { calculateDistance, parseDistanceToText } from '../../lib/utils'

const GOOGLE_DIRECTION_URL = 'https://www.google.com/maps/dir/?api=1'

const StyledLabel = styled.div`
  background-color: #ffffff;
  padding: 1rem;
  width: 18rem;
  border-radius: 4px;
  border: 1px solid #eaeaea;

  ${SCREEN_SIZE.Only.Mobile} {
    display: inline-block;
    border-radius: 4px;
    overflow: hidden;
  }
`

const InfoContainer = styled.div`
  color: #696969;
  > ${Text} {
    display: block;
    width: 100%;
  }
`
const BuildingAddress = styled(Text)`
  font-weight: bolder;
  text-transform: capitalize;
`

const StoreFeatures = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const FeatureButton = styled(Text)`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border: 1px solid #333333;
  border-radius: 2px;
  margin: 0.5rem 0.5rem 0.5rem 0;
`

const HeaderContainer = styled.div`
  display: flex;
`

const DirectionLink = styled.a`
  font-family: Lato, sans-serif;
  display: block;
  color: #1557bf;
  font-size: 0.875rem;
  text-decoration: none;
  font-weight: bold;
  width: max-content;
  margin-left: auto;
`

const DistanceContent = styled(Text)`
  margin-left: auto;
`

const BottomContainer = styled.div`
  display: flex;
  margin-top: 0.5rem;
  color: #696969;
`

const MarkerContent = ({ currentLocation, marker }) => {
  const directionUrl =
    marker &&
    GOOGLE_DIRECTION_URL +
      (currentLocation && currentLocation.lat && currentLocation.lng
        ? `&origin=${currentLocation.lat},${currentLocation.lng}`
        : '') +
      `&destination=${marker.lat},${marker.long}`

  const distance = calculateDistance(currentLocation, marker)
  const mapScale = 100
  const distanceText = parseDistanceToText(distance * mapScale)

  const displayWorkingTime = store => {
    let times = []
    if (store.isFullWeek) {
      if (store.is24Hour) {
        times = [`Daily, 24 Hours`]
      } else {
        times = [`Daily, ${store.fromTime} to ${store.toTime}`]
      }
    } else {
      if (store.is24Hour) {
        times = [`MON - FRI, 24 Hours`]
      } else {
        times = [`MON - FRI, ${store.fromTime} to ${store.toTime}`]
      }
      if (store.fromTimeExtra && store.toTimeExtra) {
        times.push(`SAT - SUN, ${store.fromTimeExtra} to ${store.toTimeExtra}`)
      }
    }
    return times.length === 0
      ? ''
      : times.map((time, index) => (
          <Text key={`store-time-${store.id}-${index}`}>{time}</Text>
        ))
  }

  return (
    <StyledLabel key={`marker-container-${marker.id}`}>
      <HeaderContainer>
        <Text color="#333333" size="large" weight="bold">
          {marker.storeType}
        </Text>
        {!!distance && (
          <DistanceContent color="#333333" size="medium" weight="bold">
            {distanceText}
          </DistanceContent>
        )}
      </HeaderContainer>
      <StoreFeatures>
        {marker.isSAG === true && (
          <FeatureButton color="#4a4a4a" size="small" weight="bold">
            Scan & Go
          </FeatureButton>
        )}
      </StoreFeatures>
      <InfoContainer>
        {marker.name && <BuildingAddress>{marker.name}</BuildingAddress>}
        <Text>{marker.address}</Text>
        {displayWorkingTime(marker)}
      </InfoContainer>
      <BottomContainer>
        {marker.phone && (
          <Text>
            Tel: <Text color="#1557bf">{marker.phone}</Text>
          </Text>
        )}
        <DirectionLink
          target="_blank"
          rel="noopener noreferrer"
          href={directionUrl}
        >
          Get Directions
        </DirectionLink>
      </BottomContainer>
    </StyledLabel>
  )
}

export default MarkerContent
